import { useEffect, useState } from 'react'
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { Form, Formik } from "formik";
import Person from '@mui/icons-material/PersonOutline';
import Badge from '@mui/icons-material/BadgeOutlined';
import OutlinedTextField from '../../../../components/formFields/OutlinedTextField';
import CancelButton from '../buttons/CancelButton';
import registerInitialValues from './RegisterInitialValues';
import registerValidationSchema from './RegisterValidationSchema';
import SubmitButton from '../buttons/SubmitButton';
import { useNavigate } from 'react-router-dom';
import BasesApi from '../../../../api/BasesApi';
import BaseToSelectOption from '../../../../models/GetBaseRes';
import { SelectOption } from '../../../../models/SelectOption';
import { requestRegistration } from '../../../../api/accountApi';
import Alert from '@mui/material/Alert';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import { AxiosError, AxiosResponse } from 'axios';
import { AlertTitle } from '@mui/material';

const roles = [
  {
    key: 'RESPONSABLE_FLOTA',
    value: 'Responsable de flota',
  },
  {
    key: 'LIDER_BASE',
    value: 'Líder de Base',
  },
  {
    key: 'OPERATIVO',
    value: 'Operario de Olca',
  },
  {
    key: 'ADMINISTRATIVO',
    value: 'Administrativo de Olca',
  },
  {
    key: 'CHOFER',
    value: 'Chofer',
  },
  {
    key: 'DIRECTORIO',
    value: "Directorio de Olca"
  }
]

export default function RegisterForm() {
  const navigate = useNavigate()
  const [showAlert, setShowAlert] = useState(false)
  const [showAlertOk, setShowAlertOk] = useState(false)
  let bases: SelectOption[] = []
  const [owner, setOwner] = useState({
    id: '',
    email: '',
    name: ''
  })


  const handleSubmit = (values: any, actions: any) => {
    setShowAlert(false)
    values.baseName=  values?.base;
   const baseSelect= bases?.find(b=> b.value ==values?.base);
    values.base= { "id": baseSelect?.key}
    values.emailReceives=owner?.email;
    console.log(values)
    requestRegistration(values)
    .then((it: AxiosResponse | AxiosError) => {
       if (it.status === 200) {
        setShowAlertOk(true)
          // setTimeout(() => {
          //   setShowAlertOk(false)
          //     navigate(`/web/login`, { replace: true })
           
          //   }, 10000);
      
       }else{
        setShowAlert(true)
       } 
    })
    .finally(() => {
      actions.resetForm()
    })
  }

  useEffect(() => {
    BasesApi.filter()
    .then((response) => bases = response.data.map(it => BaseToSelectOption(it)));

    BasesApi.owner().then((response)=> setOwner(response?.data))
  }, [])

  return (
      <Formik
      initialValues={registerInitialValues}
      onSubmit={handleSubmit}
      validationSchema={registerValidationSchema}
      isInitialValid={false}
    >
      {({ isSubmitting, isValid, values }) => (
        <Form id="register">
          <Box sx={{margin: '0 6%'}}>
            <Box sx={{ display: 'flex' }}>
              <Person sx={{ m: 2, color: '#008F39' }} />
              <OutlinedTextField
                              label="Nombre"
                              name="firstName"
                              requiredField
                              fullWidth={true}
                            />
            </Box>
            <Box sx={{ display: 'flex' }}>
              <Box className="fakeFormIcon"></Box>
              <OutlinedTextField
                              label="Apellido"
                              name="lastName"
                              requiredField
                              fullWidth={true}
                            />
            </Box>
            <Box sx={{ display: 'flex' }}>
              <Box className="fakeFormIcon"></Box>
              <OutlinedTextField
                              label="E-mail"
                              name="email"
                              requiredField
                              fullWidth={true}
                            />
            </Box>
            <Box sx={{ display: 'flex' }}>
              <Box className="fakeFormIcon"></Box>
              <OutlinedTextField
                              label="Teléfono"
                              name="phone"
                              requiredField
                              fullWidth={true}
                            />
            </Box>
            <Box sx={{ display: 'flex' }}>
              <Box className="fakeFormIcon"></Box>
              <OutlinedTextField
                              label="DNI"
                              name="dni"
                              fullWidth={true}
                            />
            </Box>
          </Box>
          <Box sx={{margin: '0 6%'}}>
            <Divider variant="middle" style={{margin: '0 0 23px', background: '#B4B4B3'}} />
            <Box sx={{ display: 'flex' }}>
              <Badge sx={{ m: 2, color: '#008F39' }} />
              <OutlinedTextField
                              label="Empresa"
                              name="companyName"
                              requiredField
                              fullWidth={true}
                            />
            </Box>
            <Box sx={{ display: 'flex' }}>
              <Box className="fakeFormIcon"></Box>
              <OutlinedTextField
                              label="Función"
                              name="role"
                              requiredField
                              fullWidth={true}
                              options={roles}
                            />
            </Box>
            <Box sx={{ display: 'flex' }}>
              <Box className="fakeFormIcon"></Box>
              <OutlinedTextField
                              label="Base"
                              name="base"
                              requiredField
                              fullWidth={true}
                              options={bases}
                            />
            </Box>
            <Divider sx={{margin: '0', background: '#B4B4B3'}} variant="middle" />
            { showAlert &&
              <Alert severity='error' icon={<CheckCircleOutline className="register-alert-error-icon"/>} className="register-alert-error">
                El email ya está registrado
              </Alert>
            }
            {showAlertOk &&    <Alert severity='success'
            iconMapping={{
                success: <CheckCircleOutline />,
            }}
            sx={{backgroundColor: '#D8E9C8'}}>
            <AlertTitle >Hemos enviado un mail al Administrador</AlertTitle>
            <Box ></Box>
        </Alert>}
          </Box>
          <Box className="centered" sx={{padding: '23px 0'}}>
            <CancelButton></CancelButton>
            <SubmitButton isValid={isValid} isSubmitting={isSubmitting}></SubmitButton>
          </Box>
        </Form>
      )}
    </Formik>
  )
}
